import { useEffect, useCallback, useState } from 'react';

import { useSelector } from 'react-redux';
import { isExploringDemoSelector } from 'selectors/loggedInEmployee';

export function useIsExploringDemo() {
  const isExploringDemo = useSelector(isExploringDemoSelector);
  return isExploringDemo;
}

export function useOwnersState(owners) {
  const [currentOwners, setCurrentOwners] = useState(owners);
  useEffect(() => {
    setCurrentOwners(owners);
  }, [JSON.stringify(owners)]);
  const updateOwners = useCallback((newOwners) => {
    setCurrentOwners([...newOwners]);
  }, []);
  const removeOwner = useCallback(
    (toRemoveOwner) => {
      const newOwners = currentOwners.filter((owner) => owner.id !== toRemoveOwner.id);
      setCurrentOwners(newOwners);
    },
    [JSON.stringify(currentOwners)]
  );
  const restoreOwners = useCallback(() => {
    setCurrentOwners([...owners]);
  }, [JSON.stringify(owners)]);
  return { currentOwners, updateOwners, removeOwner, restoreOwners };
}
